import { render, staticRenderFns } from "./ticket-timer.vue?vue&type=template&id=6f6b4604&scoped=true"
import script from "./ticket-timer.vue?vue&type=script&lang=js"
export * from "./ticket-timer.vue?vue&type=script&lang=js"
import style0 from "./ticket-timer.vue?vue&type=style&index=0&id=6f6b4604&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6b4604",
  null
  
)

export default component.exports